import Users from '@/views/users/Users.vue'

export default [
  {
    path: 'usuarios',
    name: 'users.list',
    component: Users
  }
]
